import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAppInstallationsKey, getAppsKey } from '../../utils/keys';
export const useUninstallApp = (options) => {
    const { useMutationOptions, fields = 'basic' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.app.uninstall(input, fields), {
        onMutate: variables => {
            const appInstallationsKey = getAppInstallationsKey();
            queryClient.setQueriesData(appInstallationsKey, old => {
                var _a;
                return ({
                    ...old,
                    pages: (_a = old === null || old === void 0 ? void 0 : old.pages) === null || _a === void 0 ? void 0 : _a.map(page => {
                        var _a, _b;
                        return ({
                            ...page,
                            edges: (_a = page === null || page === void 0 ? void 0 : page.edges) === null || _a === void 0 ? void 0 : _a.filter(edge => { var _a; return ((_a = edge === null || edge === void 0 ? void 0 : edge.node) === null || _a === void 0 ? void 0 : _a.id) !== (variables === null || variables === void 0 ? void 0 : variables.appInstallationId); }),
                            nodes: (_b = page === null || page === void 0 ? void 0 : page.nodes) === null || _b === void 0 ? void 0 : _b.filter(node => (node === null || node === void 0 ? void 0 : node.id) !== (variables === null || variables === void 0 ? void 0 : variables.appInstallationId)),
                        });
                    }),
                });
            });
        },
        onSettled: () => {
            const appsKey = getAppsKey();
            queryClient.invalidateQueries(appsKey);
            const appInstallationsKey = getAppInstallationsKey();
            queryClient.invalidateQueries(appInstallationsKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useUninstallApp.js.map